import Open from './Open/Open';
import InsertDeleteRow from './InsertDeleteRow/InsertDeleteRow';
import InsertDeleteColumn from './InsertDeleteColumn/InsertDeleteColumn';
import Copy from './Copy/Copy';
import Paste from './Paste/Paste';
import CreatePivot from './CreatePivot/CreatePivot';
import ExportCsv from './ExportCSV/ExportCsv';
import WriteCell from './WriteCell/WriteCell';
import WriteRange from './WriteRange/WriteRange';
import VLookUp from './VLookUp/VLookUp';
import ReadSheet from './ReadSheet/ReadSheet';
import ReadFile from './ReadFile/ReadFile';
import Save from './Save/Save';
import SetCellFormula from './SetCellFormula/SetCellFormula';
import RunMacro from './RunMacro/RunMacro';
import NewFile from './NewFile/NewFile';
import Search from './Search/Search';
import DeleteCell from './DeleteCell/DeleteCell';
import Filter from './Filter/Filter';
import Find from './Find/Find';

import { types } from './types';

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert -  show alert
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Actions(action, showAlert, variables, setOpenVariable, automId, automVersionId, getVariables, variableRender, automDetail) {

    switch (action.actionName) {
        case types.OPEN:
            return <Open action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automId={automId} />;
        case types.INSDELROW:
            return <InsertDeleteRow action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.INSDELCOL:
            return <InsertDeleteColumn action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.COPY:
            return <Copy action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.PASTE:
            return <Paste action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.PIVOT:
            return <CreatePivot action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.EXPORTCSV:
            return <ExportCsv action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automId={automId} />;
        case types.WRITECELL:
            return <WriteCell action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.VLOOKUP:
            return <VLookUp action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.READSHEET:
            return <ReadSheet action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automId={automId} automVersionId={automVersionId} getVariables={getVariables} />;
        case types.READFILE:
            return <ReadFile action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automId={automId} automVersionId={automVersionId} getVariables={getVariables} />;
        case types.SAVE:
            return <Save action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automId={automId} />;
        case types.SETCELLFORMULA:
            return <SetCellFormula action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.RUNMACRO:
            return <RunMacro action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automId={automId} />;
        case types.WRITERANGE:
            return <WriteRange action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.NEWFILE:
            return <NewFile action={action} variables={variables}
                setOpenVariable={setOpenVariable} automId={automId} />;
        case types.SEARCH:
            return <Search action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.DELETECELL:
            return <DeleteCell action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} />;
        case types.FILTER:
            return <Filter action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automDetail={automDetail} automId={automId} automVersionId={automVersionId} variableRender={variableRender} />;
        case types.FIND:
            return <Find action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automDetail={automDetail} automId={automId} automVersionId={automVersionId} variableRender={variableRender} />;
        default:
            break;
    }
}

export default Actions;
